import {
  A3_FORMAT,
  ALL_CONTENT_FORMAT,
  ARCH_C_FORMAT,
  ARCH_D_FORMAT,
  TABLOID_FORMAT
} from '../../constants';

export const TABS = { GENERAL: 1, CUSTOMIZATION: 2 };
export const PAPER_FORMAT = [
  ALL_CONTENT_FORMAT,
  TABLOID_FORMAT,
  A3_FORMAT,
  ARCH_C_FORMAT,
  ARCH_D_FORMAT
];
